import Link from "next/link";

const LinkForLanguage = Link
export default LinkForLanguage